import React from "react";
import { TextField, Box } from "@mui/material";
import InputIcon from "@mui/icons-material/Input";

const Icon = ({ IconProp, ...props }) => {
  return <IconProp {...props} width={20} height={20} />;
};

const Input = ({ label, icon, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "50px",
        position: "relative",
      }}
    >
      <TextField
        id="input-with-sx"
        label={label}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
        {...props}
        sx={{
          width: "100%",
          height: "100%",
          margin: 0,
          background: "#fff",
          paddingLeft: "8px",

          "& .MuiInput-root": {
            height: "100%",
          },
          "& .MuiInput-input": {
            height: "100%",
            paddingBottom: 0,
            fontSize: 16,
            transition: "0.3s ease-in-out",
            paddingLeft: "5px",

            "&:-webkit-autofill": {
              WebkitBoxShadow: `0 0 0 1000px transparent inset`,
              WebkitTextFillColor: "#000",
              transition: "background-color 5000s ease-in-out 0s",
            },
            "&:-webkit-autofill:focus": {
              WebkitBoxShadow: `0 0 0 1000px transparent inset`,
              WebkitTextFillColor: "#000",
              transition: "background-color 5000s ease-in-out 0s",
            },
          },
          "& .MuiInputLabel-root": {
            top: 25,
            transform: "translateY(-50%)",
            fontSize: "18px",
            color: "#090E29",
            paddingLeft: "8px",
            transition: "0.3s ease-in-out",
            opacity: 0.5,
          },
          "& .MuiInputLabel-root.Mui-focused": {
            top: 12,
            fontSize: "12px",
            color: "#090E29",
          },
          "& .MuiInputLabel-root.MuiInputLabel-shrink": {
            top: 12,
            fontSize: "10px",
            color: "#090E29",
          },
          "& .MuiFormHelperText-root": {
            fontSize: "10px !important",
            marginTop: "17px",
          },
          "& .MuiInputBase-root": {
            marginTop: "10px !important",
          },
        }}
      />
    </Box>
  );
};

export default Input;
